/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import { ConfigProvider, Flex, List, Popover, Typography } from 'antd';
import IconCategories from 'Assets/icons/categories.svg';
import IconCamera from 'Assets/images/commons/camera.svg';
import IconInvite from 'Assets/images/commons/invite.svg';
import IconSend from 'Assets/images/commons/send.png';
import IconSendActive from 'Assets/images/commons/send_active.png';
import classnames from 'classnames';
import { fileTypeByMime } from 'Constants/commons';
import { CONSULT_ACCEPTED, CONSULT_TYPE_FOLLOW_UP } from 'Constants/consults';
import { MESSAGE_TYPE_FILE, MESSAGE_TYPE_MEDIA, MESSAGE_TYPE_TEXT } from 'Constants/message-types';
import { TAB_DOCTOR, TAB_PATIENT } from 'Constants/webchat';
import { any, bool, func, number, shape } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { uploadFileToSend } from 'Redux/modules/files/actions';
import { addModal } from 'Redux/modules/modal/actions';
import * as Actions from 'Redux/modules/webChat/actions';
import { Button, Form, Icon, Popup, Segment, TextArea } from 'semantic-ui-react';

import MessageMedia from '../MessageBody/MessageList/MessageItem/MessageMedia';

import AttachmentButton from './AttachmentButton';
import ModalCapture from './ModalCapture';
import ModalDoctorInvite from './ModalDoctorInvite/ModalDoctorInvite';
import styles from './TextComposer.less';

function dataURLtoFile(dataUrl, filename) {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n > 0) {
    n -= 1;
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

class TextComposer extends Component {
  constructor(props) {
    super(props);
    this.sendText = this.sendText.bind(this);
    this.state = {
      value: '',
      isModalCaptureOpen: false,
      isModalDoctorOpen: false,
      isChatBarCollapsed: false,
    };
    this.sectionRef = React.createRef(null);
  }

  componentDidMount() {
    this.inputComposer.focus();

    this.resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        // Handle size change
        this.handleSizeChange(entry.contentRect);
      });
    });
    if (this.sectionRef?.current) {
      this.resizeObserver.observe(this.sectionRef?.current);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      files: {
        status: { uploadingToSend },
        data,
      },
      toggleStatusUploadingFile,
      conversationActive,
      uploadGroup,
    } = this.props;
    const channelUuid = conversationActive?.channelId || null;
    const {
      files: {
        status: { uploadingToSend: prevUploadingToSend },
      },
    } = prevProps;

    if (prevUploadingToSend === 0 && uploadingToSend === 1 && channelUuid === uploadGroup) {
      if (!data?.mime) return;

      const fileType = fileTypeByMime(data?.mime);
      if (fileType === 'image') {
        this.sendImage(data, channelUuid);
      } else {
        this.sendFile(data, channelUuid);
      }

      toggleStatusUploadingFile();
    }
  }

  handleSizeChange = contentRect => {
    if (contentRect.width < 400) {
      this.setState({ isChatBarCollapsed: true });
    } else {
      this.setState({ isChatBarCollapsed: false });
    }
  };

  onChange = (event, { value }) => {
    this.setState({ value });
  };

  uploadImageFromBase64 = base64 => {
    const file = dataURLtoFile(base64, 'Image.png');
    this.uploadImage(file);
  };

  // eslint-disable-next-line class-methods-use-this
  handleAutoHeightChatBox = (e, lineHeight = 0) => {
    e.currentTarget.style.height = `auto`;
    const height = e.currentTarget.scrollHeight;
    e.currentTarget.style.height = `${height + lineHeight}px`;
  };

  onKeyPress = e => {
    if (e.keyCode === 13 && e.shiftKey) {
      e.preventDefault();
      this.setState(preState => ({ value: `${preState.value}\n` }));
      this.handleAutoHeightChatBox(e, 18);
      return;
    }
    if (e.keyCode === 13) {
      e.preventDefault();
      this.sendText();
      e.currentTarget.style.height = `auto`;
    }
  };

  toggleModalCapture = () => {
    this.setState(preState => ({ isModalCaptureOpen: !preState.isModalCaptureOpen }));
  };

  toggleModalDoctor = () => {
    this.setState(preState => ({ isModalDoctorOpen: !preState.isModalDoctorOpen }));
  };

  openVideo = () => {
    const {
      addModalAction,
      openVideo,
      conversationActive: {
        id: conversationid,
        latestConsult: { id: consultId },
        patient,
      },
    } = this.props;
    navigator.mediaDevices.enumerateDevices().then(devices => {
      const microphones = devices.filter(d => d.kind === 'audioinput');
      const cameras = devices.filter(d => d.kind === 'videoinput');
      if (cameras.length > 0 && microphones.length > 0) {
        openVideo(consultId, conversationid, patient);
      } else {
        let message =
          // eslint-disable-next-line max-len
          'Camera is required for video call tele-consultation. Please connect one and then restart your browser if necessary.';
        let title = 'No camera detected.';
        if (microphones.length <= 0) {
          message =
            // eslint-disable-next-line max-len
            'Microphone is required for video call tele-consultation. Please connect one and then restart your browser if necessary.';
          title = 'No microphone detected.';
        }
        addModalAction({
          type: 'commonModal',
          id: 1,
          data: {
            title,
            content: message,
            size: 'tiny',
          },
        });
      }
    });
  };

  uploadImage = file => {
    const { conversationActive } = this.props;

    const channelUuid = conversationActive?.channelId || null;
    if (channelUuid) {
      this.props.setUploadGroup(channelUuid);
      this.props.toggleStatusUploadingFile();
      const formData = new FormData();
      formData.append('file', file);
      formData.append('is_public ', true);
      return this.props.uploadFile(formData);
    }
  };

  sendMessage = (type = MESSAGE_TYPE_TEXT, message, channelUuid) => {
    const {
      conversationActive: {
        latestConsult: { id: consultId, doctorConversation, memberUuids, doctorUuids, consultType },
        id: conversationId,
      },
      doctor: { userUuid, fullName },
      sendMessage,
      activeTab,
      clearReplyMessage,
      replyMessageState,
    } = this.props;
    let metadata = {
      consultId,
      conversationId,
      consultType,
      senderName: fullName,
    };

    let channel = channelUuid;

    if (activeTab === TAB_DOCTOR) {
      metadata = {
        conversationId: doctorConversation.id,
        consultId,
        consultType,
        senderName: fullName,
      };
      channel = doctorConversation.channelId;
    }

    const data = {
      user: userUuid,
      channel,
      type,
      sentAt: Date.now(),
      message,
      metadata,
    };
    if (replyMessageState) {
      data.parent = {
        id: replyMessageState.id,
        type: replyMessageState.type,
        user: replyMessageState.user,
        message: replyMessageState.message,
        metadata: replyMessageState.metadata,
      };
      clearReplyMessage();
    }

    // private chat for doctors only
    if (activeTab === TAB_DOCTOR) {
      const recipient = doctorUuids;
      sendMessage(channel, { ...data, recipient });
    } else {
      const recipient = memberUuids;
      sendMessage(channel, { ...data, recipient });
    }
  };

  sendImage = (image, channelUuid) => {
    const message = { media: [image] };
    this.sendMessage(MESSAGE_TYPE_MEDIA, message, channelUuid);
  };

  sendFile = (file, channelUuid) => {
    const message = { file: [file] };
    this.sendMessage(MESSAGE_TYPE_FILE, message, channelUuid);
  };

  sendText = () => {
    const {
      conversationActive: { channelId: channelUuid },
    } = this.props;
    const { value } = this.state;
    const newValue = value.replace(/(^\s*(?!.+)\n+)|(\n+\s+(?!.+)$)/g, '').trim();
    if (newValue) {
      this.sendMessage(MESSAGE_TYPE_TEXT, { text: newValue }, channelUuid);
      this.setState({ value: '' });
    }
  };

  handleSetFocusedChat = id => {
    const { isMinimize, setJumpMessage } = this.props;
    setJumpMessage(null);
    if (isMinimize) this.props.setFocusedChat(id);
  };

  handleRemoveMessage = () => {
    const { clearReplyMessage } = this.props;
    clearReplyMessage();
  };

  render() {
    const { isModalCaptureOpen, value, isModalDoctorOpen, isChatBarCollapsed } = this.state;
    const {
      conversationActive,
      toggleStatusUploadingFile,
      doctor: { id: doctorId, userUuid },
      activeTab,
      isMinimize,
      replyMessage,
      zoomInfo,
      replyMessageState,
      consult,
    } = this.props;
    const { latestConsult } = conversationActive ?? { latestConsult: undefined };
    const { status, consultType } = latestConsult ?? {
      forPatient: undefined,
      status: undefined,
    };

    const isFollowup = consultType === CONSULT_TYPE_FOLLOW_UP;
    const hasDisableChat = status !== CONSULT_ACCEPTED;

    const isMainDoctor = doctorId === consult?.doctor?.id;

    const isTabPatient = activeTab === TAB_PATIENT;
    const disabledVideoCall = hasDisableChat || !isTabPatient || zoomInfo?.id;

    let replyGroupId =
      activeTab === TAB_DOCTOR
        ? conversationActive?.latestConsult?.doctorConversationId
        : conversationActive?.id;
    if (activeTab === TAB_PATIENT) {
      Object.keys(replyMessage || {}).forEach(e => {
        if (replyMessage[e].metadata.consultId === latestConsult.id) replyGroupId = e;
      });
    }

    const isShowVideoCall = !(hasDisableChat || !isTabPatient || isFollowup) && isMainDoctor;

    return (
      <Segment className="footer" disabled={hasDisableChat}>
        <div className={styles.wrapfooter} ref={this.sectionRef}>
          {replyMessageState && (
            <div className={styles.wrapReply}>
              <div className={styles.nameReply}>
                <span>
                  Replying to
                  <b>
                    {replyMessageState?.user === userUuid
                      ? ' Me'
                      : ` ${replyMessageState?.metadata.senderName}`}
                  </b>
                  :
                </span>
                <div className={styles.replyImage}>
                  {replyMessageState?.message?.media && (
                    <MessageMedia
                      message={replyMessageState}
                      conversationId={replyMessageState?.metadata.conversationId}
                    />
                  )}
                  <Icon name="close" onClick={() => this.handleRemoveMessage(replyGroupId)} />
                </div>
              </div>
              <div className={styles.contentReply}>{replyMessageState?.message.text}</div>
            </div>
          )}
          <div className={styles.wrapFunction}>
            {isChatBarCollapsed ? (
              <ConfigProvider
                theme={{
                  components: {
                    Popover: {
                      paddingContentHorizontal: 0,
                      paddingContentVertical: 0,
                      zIndexPopup: 1,
                    },
                  },
                }}>
                <Popover
                  classNames={{
                    body: styles.popoverContent,
                  }}
                  content={
                    <List>
                      {isShowVideoCall && (
                        <List.Item>
                          <Typography.Text>
                            <Button
                              className={styles.buttonIcon}
                              basic
                              icon
                              onClick={this.toggleModalDoctor}
                              as="span">
                              <Flex gap={8} align="center">
                                <img src={IconInvite} alt="invite" /> {/* NOSONAR */}
                                Invite Providers
                              </Flex>
                            </Button>
                          </Typography.Text>
                        </List.Item>
                      )}
                      {!disabledVideoCall && (
                        <List.Item>
                          <Typography.Text>
                            <Button
                              basic
                              icon
                              className={styles.buttonIcon}
                              onClick={this.openVideo}
                              as="span">
                              <Flex gap={8} align="center">
                                <img src={IconCamera} alt="camera" /> Start Video Call
                              </Flex>
                            </Button>
                          </Typography.Text>
                        </List.Item>
                      )}
                      {!replyMessage?.[replyGroupId] && (
                        <List.Item>
                          <Typography.Text>
                            <AttachmentButton
                              disabled={hasDisableChat}
                              toggleStatusUploadingFile={toggleStatusUploadingFile}
                              uploadImage={this.uploadImage}
                              isMinimize={isMinimize}
                              buttonTex="Attach a Media"
                            />
                          </Typography.Text>
                        </List.Item>
                      )}
                    </List>
                  }>
                  <img src={IconCategories} alt="categories" style={{ marginRight: 12 }} />
                </Popover>
              </ConfigProvider>
            ) : (
              <Button.Group
                basic
                className={classnames({ [styles.buttonGroupHidden]: value !== '' })}
                style={{ transition: '0.4s' }}>
                {!disabledVideoCall && (
                  <Popup
                    content="Call"
                    inverted
                    size="mini"
                    trigger={
                      <Button
                        basic
                        icon
                        className={styles.buttonIcon}
                        onClick={this.openVideo}
                        as="span">
                        <img src={IconCamera} alt="camera" />
                      </Button>
                    }
                  />
                )}
                {isShowVideoCall && (
                  <Popup
                    content="Invite"
                    inverted
                    size="mini"
                    trigger={
                      <Button
                        className={styles.buttonIcon}
                        basic
                        icon
                        onClick={this.toggleModalDoctor}
                        as="span">
                        <img src={IconInvite} alt="invite" />
                      </Button>
                    }
                  />
                )}
                {!replyMessage?.[replyGroupId] && (
                  <Popup
                    content="Attachment"
                    inverted
                    size="mini"
                    trigger={
                      <div>
                        <AttachmentButton
                          disabled={hasDisableChat}
                          toggleStatusUploadingFile={toggleStatusUploadingFile}
                          uploadImage={this.uploadImage}
                          isMinimize={isMinimize}
                        />
                      </div>
                    }
                  />
                )}
              </Button.Group>
            )}
            <Form onSubmit={this.onSubmit}>
              <TextArea
                placeholder="Type a message"
                ref={ref => {
                  this.inputComposer = ref;
                }}
                value={value}
                onChange={this.onChange}
                disabled={hasDisableChat}
                rows={1}
                onInput={e => this.handleAutoHeightChatBox(e, 0)}
                id={`composer_${replyGroupId}`}
                style={{
                  backgroundColor: '#f0f0f0',
                  borderRadius: 8,
                  minHeight: 40,
                  resize: 'none',
                  maxHeight: 200,
                  lineHeight: '18px',
                }}
                onKeyDown={this.onKeyPress}
                onFocus={() => this.handleSetFocusedChat(conversationActive.id)}
                onBlur={() => this.handleSetFocusedChat(null)}
              />
            </Form>
            <Button
              basic
              icon
              style={{ marginLeft: '12px' }}
              className={styles.buttonIcon}
              onClick={this.sendText}
              as="span">
              {value === '' ? (
                <img src={IconSend} alt="send" />
              ) : (
                <img src={IconSendActive} alt="active icon" />
              )}
            </Button>
            {isModalCaptureOpen && (
              <ModalCapture
                toggleModalCapture={this.toggleModalCapture}
                uploadImage={this.uploadImageFromBase64}
              />
            )}
            {isModalDoctorOpen && (
              <ModalDoctorInvite
                close={this.toggleModalDoctor}
                conversationActive={conversationActive}
                doctorId={doctorId}
              />
            )}
          </div>
        </div>
      </Segment>
    );
  }
}

TextComposer.propTypes = {
  doctor: shape({}).isRequired,
  files: shape({}).isRequired,
  replyMessageState: shape({}),
  replyMessage: shape({}),
  zoomInfo: shape({}),
  activeTab: number,
  openVideo: func.isRequired,
  setJumpMessage: func.isRequired,
  clearReplyMessage: func.isRequired,
  uploadFile: func.isRequired,
  uploadGroup: any,
  addModalAction: func.isRequired,
  conversationActive: shape({}).isRequired,
  sendMessage: func.isRequired,
  toggleStatusUploadingFile: func.isRequired,
  setFocusedChat: func.isRequired,
  setUploadGroup: func.isRequired,
  isMinimize: bool,
  consult: shape({}).isRequired,
};

TextComposer.defaultProps = {
  activeTab: TAB_PATIENT,
  isMinimize: false,
  replyMessageState: {},
  replyMessage: {},
  zoomInfo: {},
};

const mapStateToProps = state => ({
  files: state.files,
  consultMembers: state.webChat.consults.members,
  consultId: state.webChat.video.consultId,
  uploadGroup: state.webChat.commons.uploadGroup,
  replyMessage: state.webChat.messages.replyMessage,
  focusedChat: state.webChat.commons.focusedChat,
  zoomInfo: state.webChat.video.zoomInfo,
});

const mapDispatchToProps = {
  uploadFile: uploadFileToSend,
  toggleStatusUploadingFile: Actions.toggleStatusUploadingFile,
  openVideo: Actions.openVideo,
  setJumpMessage: Actions.setJumpMessage,
  setFocusedChat: Actions.minimumBubbleFocused,
  setUploadGroup: Actions.setUploadGroup,
  addModalAction: addModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(TextComposer);
